<template>
    <form>
        <div class="orangeBackground">
            <div class="col-12" v-if="success">
                <div class="text-center" v-if="news">
                    <div class="largeText">Pozdravljeni,</div>
                    <br>
                    Na elektronski naslov smo vam poslali potrditveno sporočilo.<br>
                    <br>
                    Prosimo potrdite prijavo s klikom na povezavo v sporočilu.<br>
                    <br>
                    Hvala.
                </div>
                <div class="text-left" v-else>
                    <div class="largeText">Pozdravljeni,</div>
                    <br>
                    Na elektronski naslov smo vam poslali potrditveno sporočilo.<br>
                    <br>
                    Prosimo potrdite prijavo s klikom na povezavo v sporočilu.<br>
                    <br>
                    Hvala.
                </div>
            </div>
            <div v-else>
                <div class="largeText">{{ title }}</div>
                <div class="smallText">{{ subtitle }}</div>
                <div class="row" v-if="news">
                    <div class="col-12 col-xl-6 col-xxl-4 offset-xxl-2">
                        <div class="form-group">
                            <input id="newsletter_name" :class="['form-control',  {'is-invalid': form.errors.has('name')}]" type="text" v-model="form.name" required>
                            <label for="newsletter_name">{{ name }}</label>
                        </div>
                    </div>
                    <div class="col-12 col-xl-6 col-xxl-4 ">
                        <div class="form-group">
                            <input id="newsletter_email" :class="['form-control',  {'is-invalid': form.errors.has('email')}]" type="text" v-model="form.email" required>
                            <label for="newsletter_email">{{ email }}</label>
                        </div>
                    </div>
                </div>
                <div class="row" v-if="news">
                    <div class="col-12 col-xl-6 col-xxl-4 offset-xxl-2">
                        <div class="checkbox">
                            <label>
                                <input value="1" type="checkbox" v-model="form.privacy" />
                                <span :class="{'is-invalid': form.errors.has('privacy')}" v-html="privacy"></span>
                            </label>
                        </div>
                    </div>
                    <div class="col-12 col-xl-6 col-xxl-4">
                        <button class="btn btn-primary" type="submit" v-if="!success" @click.prevent="signup">{{ btn }}</button>
                    </div>
                </div>
                <div class="form-group" v-if="!news">
                    <input id="newsletter_name" :class="['form-control',  {'is-invalid': form.errors.has('name')}]" type="text" v-model="form.name" required>
                    <label for="newsletter_name">{{ name }}</label>
                </div>
                <div class="form-group" v-if="!news">
                    <input id="newsletter_email" :class="['form-control',  {'is-invalid': form.errors.has('email')}]" type="text" v-model="form.email" required>
                    <label for="newsletter_email">{{ email }}</label>
                </div>
                <div class="checkbox" v-if="!news">
                    <label>
                        <input value="1" type="checkbox" v-model="form.privacy" />
                        <span :class="{'is-invalid': form.errors.has('privacy')}" v-html="privacy"></span>
                    </label>
                </div>
            </div>
        </div>
        <button class="btn btn-primary" type="submit" v-if="!success && !news" @click.prevent="signup">{{ btn }}</button>
    </form>
</template>

<script>
import to from '@Utils/to'
import Request from '@Utils/request'

export default {
    props: {
        title: {
            default:  ""
        },
        subtitle: {
            default:  ""
        },
        name: {
            default:  ""
        },
        email: {
            default:  ""
        },
        privacy: {
            default:  ""
        },
        successtitle: {
            default:  ""
        },
        successbody: {
            default:  ""
        },
        btn: {
            default:  ""
        },
        news: {
            default: false
        },
    },

    data() {
        return {
            success: false,
            loading: false,
            form: new Request({
                privacy: false,
                email: '',
                name: ''
            })
        }
    },

    methods: {
        async signup() {
            this.loading = true;
            let [err, response] = await to(this.form.post('/newsletter'))
            this.success = response && response.success
            this.loading = false;
        }
    }
}
</script>
